<template>
    <div>
  
      <Dialog :visible.sync="exibirModal" :header="titulo" :modal="true" :style="{width: '40vw'}" @hide="fechar">    
        <div v-if="itemPendente">    
            <label class="p-text-bold">{{ dados.solicitacao.funcionario.nomecc }}</label>
            <hr>
            <div class="p-fluid p-formgrid p-grid"> 
                <div class="p-field p-col-6">
                    <label>Data da Solicitação</label>
                    <InputText class="input-readonly" v-model="dados.solicitacao.data" readonly/>
                </div>
                <div class="p-field p-col-6">
                    <label>Data do Ponto <span class="p-text-bold" v-if="alteracao">(Editado)</span></label>
                    <InputText class="input-readonly" v-model="dados.solicitacao.dataPonto" readonly/>	
                </div> 
                <div class="p-field p-col-12 p-md-12" v-if="novo">
                    <label>Justificativa</label>
                    <InputText class="input-readonly" v-model.trim="itemPendente.justificativa.descricao" readonly/>
                </div>                 
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-2">
                    <label>1ª Entrada</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios1[0]" readonly/>				
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>1ª Saída</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios1[1]" readonly/>		
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>2ª Entrada</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios1[2]" readonly/>		
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>2ª Saída</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios1[3]" readonly/>	
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>3ª Entrada</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios1[4]" readonly/>		
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>3ª Saída</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios1[5]" readonly/>	
                </div>  
            </div>

            <div class="p-fluid p-formgrid p-grid" v-if="alteracao">
                <div class="p-field p-col-12 p-mt-3 p-mb-0">
                  <hr class="p-mt-0">
                </div>
                <div class="p-field p-col-6">
                    <label>Data do Ponto <span class="p-text-bold">(Novo)</span></label>
                    <InputText class="input-readonly" v-model="dataPontoAlteracao" readonly/>	
                </div> 
                <div class="p-field p-col-12 p-md-6">
                    <label>Justificativa</label>
                    <InputText class="input-readonly" v-model.trim="itemPendente.justificativa.descricao" readonly/>
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>1ª Entrada</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios2[0]" readonly/>				
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>1ª Saída</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios2[1]" readonly/>		
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>2ª Entrada</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios2[2]" readonly/>		
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>2ª Saída</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios2[3]" readonly/>	
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>3ª Entrada</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios2[4]" readonly/>		
                </div>
                <div class="p-field p-col-12 p-md-2">
                    <label>3ª Saída</label>
                    <InputText class="input-readonly p-text-center" v-model="horarios2[5]" readonly/>	
                </div>  
            </div>
            
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-12">
                    <label class="p-text-bold">Ação</label>
                    <Dropdown v-model="acaoSelecionada" :options="acoes" optionLabel="nome" 
                    optionValue="id" placeholder="Selecione" appendTo="body" 
                    :disabled="!exibirBotoes" :class="!exibirBotoes ? 'input-readonly' : ''"/>
                </div> 
                <div class="p-field p-col-12 p-md-12" v-if="acaoSelecionada == naoAprovado">
                    <label class="p-text-bold">Observação</label>
                    <Textarea v-model.trim="observacaoNaoAprovado" rows="3" cols="30" 
                    :class="!exibirBotoes ? 'input-readonly' : ''" :disabled="!exibirBotoes"/>
                </div>                                 
            </div>        
        </div>
        <template #footer>
            <div class="p-d-flex p-jc-end">
                <div v-if="exibirBotoes">
                    <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirModal = false"/>
                    <Button label="Salvar" icon="pi pi-check" @click="salvar"/>                      
                </div>                              
            </div>            
        </template>        
      </Dialog>

    </div>
  </template>
  
  <script>
  import MudancaHorarioService from '@/service/MudancaHorarioService.js';
  import ControlePontoService from '@/service/ControlePontoService.js';
  import { exibirMensagemSis, exibirMensagem, acoesSolicitacoesPendentes, clonar } from '@/global';
  import { mapGetters } from 'vuex';
  
  export default {  
      controlePontoService: null,
      mudancaHorarioService: null,
      props: {
          callback: Function,
      },
      data() {
          return {  
            titulo: 'Solicitação',
            naoAprovado: 'Não Aprovado',   
            exibirModal: false,             
            itemPendente: null,          
            observacaoNaoAprovado: '',
            dados: null,
            acaoSelecionada: '',         
            acoes: acoesSolicitacoesPendentes,   
            exibirBotoes: false,
            novo: false,     
            alteracao: false,    
            dataPontoAlteracao: '', 
            horarios1: [':', ':', ':', ':', ':', ':'],
            horarios2: [':', ':', ':', ':', ':', ':'],              
          }
      },
      methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),
        /**
         * 
         * @param {*} dados 
         */
        processar(dados) {           
          this.mudancaHorarioService = new MudancaHorarioService();
          this.controlePontoService = new ControlePontoService();
          this.dados = dados; 
          this.buscarItemSolicitacao();         
        },
         /**
         * 
         * @param {*} solicitacao 
         */
         buscarItemSolicitacao() {           
            let requisicao = {
              idSolicitacao: this.dados.solicitacao.id,
              idFuncionario: this.dados.solicitacao.funcionario.id,
              dataPonto: this.formartarStrData(this.dados.solicitacao.dataPonto, 'US'),
              usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.mudancaHorarioService.buscarItemSolicitacao(requisicao)
            .then(resp => {         
              this.itemPendente = resp.data;
              this.itemPendente.infoCampo1.split(',').forEach((hr, index) => {
                this.horarios1[index] = hr;
              });
              const solicitacao = this.dados.solicitacao;
              if (solicitacao.status === 'Pendente' && this.dados.permissaoEditar) {
                this.exibirBotoes = true;
              } else {
                this.acaoSelecionada = solicitacao.status;
              }
              if(!solicitacao.observacao) {
                this.dados.solicitacao.observacao = '';
              }
              this.observacaoNaoAprovado = solicitacao.observacao;  
              if(this.itemPendente.acao === 'ATUALIZAR') {
                this.titulo = 'Solicitação | Mudança de Horário | Atualizar';
                this.novo = false;
                this.alteracao = true;
                this.itemPendente.infoCampo2.split(',').forEach((hr, index) => {
                  this.horarios2[index] = hr;
                });
                this.dataPontoAlteracao =  this.formartarStrData(this.itemPendente.infoCampo3, 'BR');
              } else if(this.itemPendente.acao === 'EXCLUIR') {
                this.titulo = 'Solicitação | Mudança de Horário | Excluir';             
                this.novo = false;         
                this.alteracao = false;      
              } else {
                this.titulo = 'Solicitação | Mudança de Horário | Novo';
                this.novo = true; 
                this.alteracao = false;             
              }
              this.exibirModal = true;
            })
            .catch(erro => {exibirMensagem(this, erro)});           
        },
        /**
         * 
         */
        salvar() { 
          if(this.acaoSelecionada == '') {
            exibirMensagemSis(this, 'Selecione uma ação', true);
            return;
          }
          if(this.acaoSelecionada === this.naoAprovado 
            && this.observacaoNaoAprovado === '') {
            exibirMensagemSis(this, 'Informe um texto breve na observação', true);
            return;
          }         
          let solicitacao = clonar(this.dados.solicitacao);
          delete solicitacao.funcionario;
          solicitacao.status = this.acaoSelecionada;
          solicitacao.observacao = this.observacaoNaoAprovado;
          solicitacao['usuarioAprovacao'] = this.dados.requisicao.usuarioRequisicao.usuario.nome;             
          if(solicitacao.origem === 'MUDANCA_HORARIO') {           
            if(this.itemPendente.acao == 'NOVO') {              
              this.resolverPendenciaNovo(solicitacao);
            } else if(this.itemPendente.acao == 'ATUALIZAR') {
              this.resolverPendenciaAlteracao(solicitacao);
            } else if(this.itemPendente.acao == 'EXCLUIR') {
              this.resolverPendenciaExcluir(solicitacao);
            }
          } else {// CTRL_MUDANCA_HORARIO
            if(this.itemPendente.acao == 'NOVO') {              
              this.resolverPendenciaCTRLNovo(solicitacao);
            } else if(this.itemPendente.acao == 'EXCLUIR') {
              this.resolverPendenciaCTRLExcluir(solicitacao);
            }
          }   
        },
        /**
         * 
         */
        resolverPendenciaNovo(solicitacaoAtualizar) {         
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            horarioFlexivel: {                
                entrada1: this.horarios1[0],
                saida1: this.horarios1[1],
                entrada2: this.horarios1[2] == ':' ? null : this.horarios1[2],
                saida2: this.horarios1[3] == ':' ? null : this.horarios1[3],
                entrada3: this.horarios1[4] == ':' ? null : this.horarios1[4],
                saida3: this.horarios1[5] == ':' ? null : this.horarios1[5]
            },
            justificativa: this.itemPendente.justificativa,
            dataInicio: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US'),
            dataFinal: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US'),
            funcionarios: [this.dados.solicitacao.funcionario],
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.mudancaHorarioService.resolverPendenciaNovo(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaAlteracao(solicitacaoAtualizar) {         
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            horarioFlexivel: {   
                id: this.itemPendente.idReferencia1,
                dia: this.itemPendente.infoCampo3,          
                entrada1: this.horarios2[0],
                saida1: this.horarios2[1],
                entrada2: this.horarios2[2] == ':' ? null : this.horarios2[2],
                saida2: this.horarios2[3] == ':' ? null : this.horarios2[3],
                entrada3: this.horarios2[4] == ':' ? null : this.horarios2[4],
                saida3: this.horarios2[5] == ':' ? null : this.horarios2[5]
            },
            justificativa: this.itemPendente.justificativa,
            funcionario: this.dados.solicitacao.funcionario,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.mudancaHorarioService.resolverPendenciaAlteracao(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaExcluir(solicitacaoAtualizar) {         
          const novaRequisicao = {
            cnpj: this.dados.requisicao.cnpj,
            solicitacao: solicitacaoAtualizar,
            horarioFlexivel: {
                id: this.itemPendente.idReferencia1,   
                dia: this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US')             
            },
            funcionario: this.dados.solicitacao.funcionario,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.mudancaHorarioService.resolverPendenciaExcluir(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaCTRLNovo(solicitacaoAtualizar) {   
          const data = this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US');      
          const novaRequisicao = {
            mes: this.dados.requisicao.mes,
            ano: this.dados.requisicao.ano,
            solicitacao: solicitacaoAtualizar,
            horarioFlexivel: {
                entrada1: this.horarios1[0],
                saida1: this.horarios1[1],
                entrada2: this.horarios1[2] == ':' ? null : this.horarios1[2],
                saida2: this.horarios1[3] == ':' ? null : this.horarios1[3],
                entrada3: this.horarios1[4] == ':' ? null : this.horarios1[4],
                saida3: this.horarios1[5] == ':' ? null : this.horarios1[5]
            },
            justificativa: this.itemPendente.justificativa,
            dataInicio: data,
            dataFinal: data,
            idFuncionario: this.dados.solicitacao.funcionario.id,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.controlePontoService.resolverNovoMudancaHorarioPendente(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         */
         resolverPendenciaCTRLExcluir(solicitacaoAtualizar) { 
          const data = this.formartarStrData(solicitacaoAtualizar.dataPonto, 'US');         
          const novaRequisicao = {
            mes: this.dados.requisicao.mes,
            ano: this.dados.requisicao.ano,
            solicitacao: solicitacaoAtualizar,
            dataInicio: data,
            dataFinal: data,
            idFuncionario: this.dados.solicitacao.funcionario.id,
            usuarioRequisicao: this.dados.requisicao.usuarioRequisicao
          }
          this.controlePontoService.resolverExcluirMudancaHorarioPendente(novaRequisicao)
          .then(resp => {
            this.fechar(); 
            exibirMensagem(this, resp);	  
            this.callback(solicitacaoAtualizar);
          })
          .catch(erro => {exibirMensagem(this, erro)});  
        },
        /**
         * 
         * @param {*} strData 
         * @param {*} formato 
         */
         formartarStrData(strData, formato) {   
            if(formato == 'BR') {
                let partes = strData.split('-');
                return partes[2] + '/' + partes[1] + '/' + partes[0];
            }
            let partes = strData.split('/');
            return partes[2] + '-' + partes[1] + '-' + partes[0]; 
        },
        /**
         * 
         */
        fechar() {
          this.exibirModal = false; 
          this.itemPendente = null;          
          this.observacaoNaoAprovado = '';
          this.dados = null;
          this.acaoSelecionada = ''; 
          this.exibirBotoes = false; 
          this.controlePontoService = null;
          this.mudancaHorarioService = null;
          this.horarios1 = [':', ':', ':', ':', ':', ':'];
          this.horarios2 = [':', ':', ':', ':', ':', ':'];
          this.titulo = 'Solicitação';
          this.novo = false;
          this.alteracao = false    
          this.dataPontoAlteracao = ''; 
        }       
      }
  }
  </script>
  
  <style scoped>
    .input-readonly {
      background-color: #F2F2F2;
    }
  </style>